import Accordion from "./Classes/Accordion";
import CountUpNumbers from "./Classes/CountUpNumbers"
import Swiper from "swiper";
import  {Navigation, Pagination} from "swiper/modules";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";

window.addEventListener("page_event_load", () => {
  new Accordion({
    accordions: '.lc-accordion__inner-head',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: 105,
    mobileBreakpoint: 1025
  });

  new Swiper('.swiper', {
    modules: [Navigation, Pagination],
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

  new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number--upcount',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['en'],
    decimalArray: ['.'],
    decimalPlaces: 0,
    thousandSepArray: [','],
  });
});

window.addEventListener('note_event_load', evt => {
  // console.log("note loaded event");
  document.body.classList.add("note-open");

  new ResponsiveTablesLight({
    tableComponentSelector: '.lc-component--table',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.lc-component--table table'
  });

});


window.addEventListener('note_unloaded', evt => {
  //console.log("note unloaded event");
  document.body.classList.remove("note-open");
});
